import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const AfeService = {
  getAfes: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/afe/getafes`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateAfe: async (afeData) => {
    try {
      const { data } = await axios.put(`${getApiUrl()}/afe/updateafe`, afeData);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  insertAfe: async (afeData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/afe/insertafe`,
        afeData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteAfe: async (afeId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/afe/deleteafe?id=${afeId}`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Nuovi metodi per gestire i cambiamenti in attesa
  getPendingChanges: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/afe/pending-changes`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updatePendingChange: async (changeData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/afe/pending-changes`,
        changeData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // In AfeService.js o OpexService.js

  getChangesHistory: async (filters = {}) => {
    try {
      let url = `${getApiUrl()}/afe/changes-history`;

      const params = new URLSearchParams();
      if (filters.startDate) params.append("StartDate", filters.startDate);
      if (filters.endDate) params.append("EndDate", filters.endDate);
      if (filters.status) params.append("Status", filters.status);

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const { data } = await axios.get(url);

      const formattedData = data.map((item) => ({
        ...item,
        modifiedAt: item.modifiedAt
          ? new Date(item.modifiedAt).toISOString()
          : null,
        handledAt: item.handledAt
          ? new Date(item.handledAt).toISOString()
          : null,
      }));

      return formattedData;
    } catch (error) {
      console.error("Error fetching change history:", error);
      console.error("Error response:", error.response?.data);
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  approvePendingChange: async (changeId, payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/afe/pending-changes/${changeId}/approve`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  rejectPendingChange: async (changeId, payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/afe/pending-changes/${changeId}/reject`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Ottieni le modifiche pendenti a livello di record
  getPendingRecordChanges: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/afe/pending-record-changes`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Crea o aggiorna una modifica pendente a livello di record
  updatePendingRecordChange: async (changeData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/afe/pending-record-changes`,
        changeData
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Approva una modifica pendente a livello di record
  approveRecordPendingChange: async (changeId, payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/afe/pending-record-changes/${changeId}/approve`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  // Rifiuta una modifica pendente a livello di record
  rejectRecordPendingChange: async (changeId, payload) => {
    try {
      const { data } = await axios.put(
        `${getApiUrl()}/afe/pending-record-changes/${changeId}/reject`,
        payload
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getRecordsWithPendingChanges: async () => {
    try {
      const { data } = await axios.get(
        `${getApiUrl()}/afe/records-with-pending-changes`
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getRecordChangeHistory: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.startDate) {
        queryParams.append("StartDate", filters.startDate);
      }

      if (filters.endDate) {
        queryParams.append("EndDate", filters.endDate);
      }

      if (filters.status) {
        queryParams.append("Status", filters.status);
      }

      const { data } = await axios.get(
        `${getApiUrl()}/afe/record-changes-history?${queryParams.toString()}`
      );

      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  setCapexRecentlyApproved: async (recordIds) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/afe/set-capex-recently-approved`,
        JSON.stringify(recordIds),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default AfeService;
